const processRoute = {
	path: ':codeProject/process',
	name: 'page-process',
	meta: {
		title: 'Procesos',
	},
	props: true,
	component: () => import('@/pages/process/page-process'),
	children: [
		{
			path: 'new',
			name: 'create-process',
			meta: {
				title: 'Crear Procesos',
			},
			props: true,
			component: () => import('@/components/process/create-process'),
		},
		{
			path: ':id/edit',
			name: 'edit-process',
			meta: {
				title: 'Editar Procesos',
			},
			props: true,
			component: () => import('@/components/process/create-process'),
		},
	],
};

export default processRoute;



// WEBPACK FOOTER //
// ./src/router/process.js